
export default {
  props: {
    showStats: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      r: this.$route,
      mapData: [
        { number: '6', text: 'oficinas' },
        { number: '4', text: 'países donde operamos' },
        { number: '70+', text: 'empleados y creciendo' },
      ]
    }
  }
}
